import React from "react";
import { Component } from "react";
import { connect } from "react-redux";
import Accordion from "@components/Accordion";
import AccordionItem from "@components/Accordion/components/AccordionItem";
import FixedAnchorageDepth from "../GeneralCalculationDesign/FixedAnchorageDepth";
import { APP_TYPES } from '@config';
import { APP_TEXTS } from "@texts";
import { setDesignType } from '@reducers/selectors/design/actions';
import { CalculationTypes } from '@reducers/selectors/design';
import "./styles.scss";

class WoodConnectionDesign extends Component {
    
  handleDesignTypeChange = () => {
    this.props.setDesignType(APP_TYPES.WOOD_CONNECTION, CalculationTypes.EN1992_TYPE_NAILS);
  };
    
  render() {
    return (
      <Accordion className="application__accordion" appStatus={this.props.appStatus}>
        <AccordionItem id="fixed_anchorage_depth" title={APP_TEXTS.DESIGN_LOADS_COMBINATION_ANCHOR_DEPTH.Content}>
          <div className="accordion-content-wrapper">
            <div className="radio-group ml-2">
              <label className="radio-label" htmlFor="anchor_type">
                <input
                  id="anchor_type"
                  type="radio"
                  name="anchor_type"
                  checked={this.props.designType === CalculationTypes.EN1992_TYPE_NAILS}
                  onChange={this.handleDesignTypeChange}
                />
                <span>{APP_TEXTS.WOOD_CONNECTION_DESIGN_ANCHORS.Content}</span>
              </label>
            </div>
            <hr/>
            <h4 className="ml-2">{APP_TEXTS.WOOD_CONNECTION_DESIGN_EMBEDMENT_DEPTH.Content}</h4>
            <FixedAnchorageDepth />
          </div>
        </AccordionItem>
      </Accordion>
    );
  }
  
}

const mapState = state => ({
  appStatus: state.main.status,
  designType: state.selectors.design[APP_TYPES.WOOD_CONNECTION].designType
});

export default connect(mapState, { setDesignType })(WoodConnectionDesign);




// WEBPACK FOOTER //
// ./src/views/Design/components/WoodConnectionDesign/index.js